import {
  BOOLEAN_FLAG,
  type FlagDefinitions,
  type ValueFlagDefinition,
} from '../types/experimentation';

export const FLAGS: FlagDefinitions = {
  NLSalaryCalculator: {
    experimentKey: '_wm__rider_landing_page_nl_salary_calculator',
    variation: BOOLEAN_FLAG.ON,
  },
  DETestimonials: {
    experimentKey: '_wm__rider_landing_page_de_testimonials_section_new_video',
    variation: BOOLEAN_FLAG.ON,
  },
};

// Spelling is deliberate: the Eppo flag key is 'appy', not 'apply'. Do not "fix" it.
export const WATERFALL_APPLY_FORM: ValueFlagDefinition = {
  experimentKey: 'waterfall_appy_form',
};
